/**
 * @description Function that returns a filtered array of aggregates where status is not "missing". Used in CurrentBillPeriodSection and LastPeriodComparison components
 * @returns Aggregate[] | undefined
 */
export const getValidAggregateTotals = (
  aggregatesData: Aggregates,
): Aggregate[] | undefined => {
  if (
    !aggregatesData ||
    !Array.isArray(aggregatesData.aggregates) ||
    aggregatesData.aggregates.length === 0
  )
    return undefined;

  return aggregatesData.aggregates.filter(
    (aggregate) => aggregate.status !== "missing",
  );
};
